module.exports = __webpack_public_path__ + "img/man.0004b1a8.png";